var render, staticRenderFns
import script from "./youtubeVideo.js?vue&type=script&lang=js&"
export * from "./youtubeVideo.js?vue&type=script&lang=js&"
import style0 from "./youtubeVideo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2930414f')) {
      api.createRecord('2930414f', component.options)
    } else {
      api.reload('2930414f', component.options)
    }
    
  }
}
component.options.__file = "src/components/youtubeVideo/youtubeVideo.vue"
export default component.exports